import { render, staticRenderFns } from "./vacaDetail.vue?vue&type=template&id=810478a6&scoped=true"
import script from "./vacaDetail.vue?vue&type=script&lang=js"
export * from "./vacaDetail.vue?vue&type=script&lang=js"
import style0 from "./vacaDetail.vue?vue&type=style&index=0&id=810478a6&prod&lang=scss&scoped=true"
import style1 from "./vacaDetail.vue?vue&type=style&index=1&id=810478a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810478a6",
  null
  
)

export default component.exports